import { render, staticRenderFns } from "./AddressAdd.vue?vue&type=template&id=454331a5&scoped=true&"
import script from "./AddressAdd.vue?vue&type=script&lang=js&"
export * from "./AddressAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454331a5",
  null
  
)

export default component.exports